document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.blog-hub').forEach(section => {

    const grid = section.querySelector('.blog-grid');
    const filters = section.querySelectorAll('[data-filter]');
    const cards = [...section.querySelectorAll('.blog-card')];
    const search = section.querySelector('.blog-search input');
    const emptyState = section.querySelector('.blog-empty-state');

    const pagination = section.querySelector('.blog-pagination');
    const dotsContainer = section.querySelector('.blog-pagination__dots');
    const prevBtn = section.querySelector('.blog-pagination__prev');
    const nextBtn = section.querySelector('.blog-pagination__next');

    if (!grid) return;

    const perPage =
      parseInt(grid.dataset.postsPerPage, 10) || 9;

    let activeFilter = 'all';
    let currentPage = 1;

    function getFilteredCards() {

      const keyword =
        search
          ? search.value.toLowerCase().trim()
          : '';

      return cards.filter(card => {

        const blog =
          (card.dataset.blog || '').toLowerCase();

        const title =
          (card.dataset.title || '').toLowerCase();

        const blogMatch =
          activeFilter === 'all' ||
          blog === activeFilter;

        const searchMatch =
          title.includes(keyword);

        return blogMatch && searchMatch;

      });

    }

    function createDots(totalPages) {

      if (!dotsContainer) return;

      dotsContainer.innerHTML = '';

      /*
       * Don't show dots when there is only one page.
       */
      if (totalPages <= 1) return;

      for (let i = 1; i <= totalPages; i++) {

        const dot =
          document.createElement('button');

        dot.type = 'button';

        dot.className =
          'blog-pagination__dot';

        dot.setAttribute(
          'aria-label',
          `Go to page ${i}`
        );

        dot.setAttribute(
          'aria-current',
          i === currentPage
            ? 'page'
            : 'false'
        );

        if (i === currentPage) {
          dot.classList.add('is-active');
        }

        dot.addEventListener('click', () => {

          currentPage = i;

          updatePagination();

          grid.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        });

        dotsContainer.appendChild(dot);

      }

    }

    function updatePagination() {

      const filteredCards =
        getFilteredCards();

      const totalPages =
        Math.max(
          1,
          Math.ceil(
            filteredCards.length / perPage
          )
        );

      /*
       * Make sure current page
       * is still valid.
       */
      if (currentPage > totalPages) {
        currentPage = totalPages;
      }

      /*
       * Hide every card first.
       */
      cards.forEach(card => {
        card.style.display = 'none';
      });

      /*
       * Calculate current page.
       */
      const start =
        (currentPage - 1) * perPage;

      const end =
        start + perPage;

      /*
       * Show cards for current page.
       */
      filteredCards
        .slice(start, end)
        .forEach(card => {
          card.style.display = '';
        });

      /*
       * Empty state.
       */
      if (emptyState) {
        emptyState.hidden =
          filteredCards.length > 0;
      }

      /*
       * Pagination.
       */
      if (pagination) {

        pagination.hidden =
          filteredCards.length <= perPage;

      }

      /*
       * Create page dots.
       */
      createDots(totalPages);

      /*
       * Previous arrow.
       */
      if (prevBtn) {

        prevBtn.disabled =
          currentPage === 1;

      }

      /*
       * Next arrow.
       */
      if (nextBtn) {

        nextBtn.disabled =
          currentPage === totalPages;

      }

    }

    /*
     * CATEGORY FILTER
     */
    filters.forEach(filter => {

      filter.addEventListener('click', () => {

        filters.forEach(item => {
          item.classList.remove('active');
        });

        filter.classList.add('active');

        activeFilter =
          filter.dataset.filter;

        currentPage = 1;

        updatePagination();

      });

    });

    /*
     * SEARCH
     */
    if (search) {

      search.addEventListener('input', () => {

        currentPage = 1;

        updatePagination();

      });

    }

    /*
     * PREVIOUS
     */
    if (prevBtn) {

      prevBtn.addEventListener('click', () => {

        if (currentPage > 1) {

          currentPage--;

          updatePagination();

          grid.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }

      });

    }

    /*
     * NEXT
     */
    if (nextBtn) {

      nextBtn.addEventListener('click', () => {

        const filteredCards =
          getFilteredCards();

        const totalPages =
          Math.ceil(
            filteredCards.length / perPage
          );

        if (currentPage < totalPages) {

          currentPage++;

          updatePagination();

          grid.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }

      });

    }

    /*
     * INITIAL LOAD
     */
    updatePagination();

  });

});